import type { InferGetStaticPropsType, NextPage } from 'next';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

import { CreditsWeb } from '#components/Credits/CreditsWeb';
import { NAVIGATION_ITEM_CREDITS } from '#config/constants';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import { createDefaultGetStaticProps } from '#cutils/page-context/server-side-static-props';
import { buildContentPageSeoConfig } from '#cutils/seo/buildContentPageSeoConfig';
import { envConfigServer } from '#sconfig/env.server';
import { useTracktor } from 'react-tracktor';

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const SEO_TITLE = 'Credits';

const Page: NextPage<Props> = () => {
	const { constants } = useEnvironment();
	const seoConfig = buildContentPageSeoConfig({ title: SEO_TITLE, url: `${constants.appUrl}/credits` });

	useTracktor({ pageViewData: { data: NAVIGATION_ITEM_CREDITS, event: { type: 'PageViewEvent' } } });

	return (
		<>
			<Head>{generateNextSeo(seoConfig)}</Head>

			<CreditsWeb />
		</>
	);
};

export const getStaticProps = createDefaultGetStaticProps(() => {
	const navigationTitle = NAVIGATION_ITEM_CREDITS.pageTitle;

	return {
		props: { navigationTitle },
		revalidate: envConfigServer.CREDITS_PAGE_TTL,
	};
});

export default Page;
